// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem_menuItem__Qveiq","label":"MenuItem_label__Fv1UF","checkIcon":"MenuItem_checkIcon__LdNCi"};